/* eslint-disable react/jsx-pascal-case */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import Breadcrumb from '../../../component/common/Breadcrumb';
import Duration from '../../../component/common/Duration';
import { ArrowDownTrayIcon, ArrowUpTrayIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { BASIC_BREATHWORK, BREATHWORK_LOTTIES, LANGUAGES, STATUS } from '../../../utils/constants';
import { Api } from '../../../api';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import CommonInput from '../../../component/common/Input/CommonInput';
import CommonTextarea from '../../../component/common/CommonTextarea';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ConfirmPopup from '../../../component/common/modals/ConfirmPopup';
import {
  MaxCharlimit,
  MaxCharlimitLongText,
  capitalizeFirstLetter,
  capitalizeWords,
  errorToast,
  getFileType,
  getLocalStorageItem,
  successToast
} from '../../../utils/helper';
import Loader from '../../../component/common/Loader';
import SecondaryButton from '../../../component/common/Buttons/SecondaryButton';
import axios from 'axios';
import FormAudioPlayer from '../../../component/AudioPlayer/FormAudioPlayer';
import LazyLoadImageProp from '../../../component/common/LazyLoadImage';
import ApprovalHistory from '../../../component/ApprovalHistory/ApprovalHistory';
import AddEditBreathworkVali from '../../../validation/AddEditBreathworkVali';
import Topbar from '../../PulseSurvey/Topbar';
import CommonSelect from '../../../component/common/select/CommonSelect';
import Icons from '../../../component/svgs/icons';
import InputWithLabel from '../../../component/common/InputWithLabel';
import TextareaWithLabel from '../../../component/common/TextareaWithLabel';
import { breathworkPageData as mainPageData } from '../../../utils/pageContent';

export default function AddEditBreathwork(props) {
  let location = useLocation();
  const [searchParams] = useSearchParams();
  let propsData = location?.state;
  const id = new URLSearchParams(window.location.search).get('id');
  let isBasicBreathwork = searchParams.get('isBasicBreathwork');
  const navigate = useNavigate();
  const captionFile = useRef(null);
  const audioRefs = useRef([]);
  const audioE1 = useRef(null);
  const breathworkFile = useRef(null);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const [minutes, setMinutes] = useState(0);
  const [minutes2, setMinutes2] = useState(0);
  const [sec, setSec] = useState(0);
  const [sec2, setSec2] = useState(0);
  const [error, setError] = useState({});
  const [selectedFile, setSelectedFile] = useState('');
  const [selectedFile2, setSelectedFile2] = useState('');
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [openConfirmPopupDraft, setOpenConfirmPopupDraft] = useState(false);
  const [selectedFile3, setSelectedFile3] = useState('');
  const [audio, setAudio] = useState('');
  const [bgAudio, setBgAudio] = useState('');
  const [video, setVideo] = useState('');
  const [selectedExpert, setSelectedExpert] = useState('');
  const [previewExpert, setPreviewExpert] = useState('');
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedBreathwork, setselectedBreathwork] = useState('');
  const [previewMeditation, setPreviewMeditation] = useState('');
  const [loader, setLoader] = useState(true);
  const [isExpertImgDeleted, setisExpertImgDeleted] = useState(false);
  const [selectedFocus, setSelectedFocus] = useState([]);
  const [isView, setIsView] = useState(false);
  const [view, setView] = useState(false);
  const [removeLanguage, setRemoveLanguage] = useState([]);
  const [openConfirmPopupSave, setOpenConfirmPopupSave] = useState(false);
  const [srtName, setSrtName] = useState(null);
  const [srtUrl, setSrtUrl] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState({});
  const [expertsList, setExpertsList] = useState([]);
  const [expertsLists, setExpertsLists] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedLottie, setSelectedLottie] = useState(null);
  const pageData = mainPageData.addEditBreathworkPageData;

  console.log(selectedCategory, 'selected category');

  const [pages, setPages] = useState([
    { name: pageData.mainPageTitle, href: '/breathwork/manage/add-edit' }
  ]);
  const [audios, setAudios] = useState([
    {
      language: '',
      audio: '',
      file: null,
      srt: '',
      duration: ''
    }
  ]);
  const [form, setForm] = useState({
    breathworkId: '',
    breathworkTitle: '',
    description: '',
    breathworkType: 1,
    breathworkBy: 1,
    status: 1,
    approvalStatus: '',
    expertName: '',
    isBasic: isBasicBreathwork == 'true' ? true : false,
    breathworkCategory: selectedCategory?.value,
    breathworkLottie: selectedLottie?.value,
    comments: []
  });
  audioRefs.current = audios?.map((_, index) => audioRefs.current[index] ?? React.createRef());

  useEffect(() => {
    if (id || (propsData?.id && propsData?.action === 'view')) {
      setView(true);
    }
  }, [id, propsData]);

  const handleChange = (e) => {
    var { name, value } = e.target;

    // Auto-capitalize based on field type
    if (name === 'breathworkTitle') {
      value = capitalizeWords(value);
      if (value !== '') {
        value = value?.slice(0, MaxCharlimit);
      }
    } else if (name === 'description') {
      value = capitalizeFirstLetter(value);
      if (value !== '') {
        value = value?.slice(0, MaxCharlimitLongText);
      }
    }

    const updatedForm = { ...form, [name]: value };
    const updatedError = { ...error, [name]: '' };
    setError(updatedError);
    if (
      !(name === 'breathworkTitle' && value?.length > MaxCharlimit) &&
      !(name === 'description' && value?.length > MaxCharlimitLongText)
    ) {
      setForm(updatedForm);
    }
  };

  const handelAudiosLanguage = (e, index) => {
    setSelectedLanguages((prev) => {
      const prevData = [...prev, e.value];
      const updatedData = prevData.filter((item) => item !== audios[index]?.language);
      return updatedData;
    });
    setAudios((prev) => {
      const prevData = [...prev];
      return prevData.map((data, i) => {
        if (i === index) {
          return { ...data, language: e?.value };
        } else {
          return data;
        }
      });
    });
    setError((prev) => {
      return {
        ...prev,
        ['language' + index]: ''
      };
    });
  };

  const handleSubmit = (e, fromPopup = false) => {
    e.preventDefault();
    const { isValid, errors } = AddEditBreathworkVali(
      form,
      selected,
      // focusListIDs,
      selectedCategory,
      // selectedFile,
      audios
      // selectedBreathwork
    );

    if (isValid) {
      // let tempFocusIdArray = selectedCategory?.map((data) => {
      //   return data?.focuses;
      // });

      // tempFocusIdArray = [].concat(...tempFocusIdArray);

      // const categorys = categoriesList
      //   ?.filter((c) => selectedCategory?.find((f) => f?.value === c?.value))
      //   ?.map((c) => c?.value);
      // console.log(categorys, 'categorys 186 ==>');
      // console.log(form, 'form 187 ==>');

      if (propsData && !fromPopup) {
        setOpenConfirmPopupSave(true);
      } else {
        setLoader(true);
        const payload = {
          breathworkId: form.breathworkId,
          breathworkName: form.breathworkTitle,
          breathworkType: form.breathworkType,
          description: form.description,
          isBasic: form.isBasic,
          isDraft: false,
          breathworkUrl: selectedFile?.type ? getFileType(selectedFile) : '',
          bg_audio: selectedFile3?.type ? getFileType(selectedFile3) : '',
          video_url: selectedFile2?.type ? getFileType(selectedFile2) : '',
          breathworkImage: selectedBreathwork?.type ? getFileType(selectedBreathwork) : '',
          expertId: selected?.id,
          expertName: selected?.name,
          duration:
            +minutes2 !== 0 || +sec2 !== 0
              ? `${minutes2}:${sec2}`
              : +minutes !== 0 || +sec !== 0
              ? `${minutes}:${sec}`
              : `${minutes}:${sec}`,
          breathworkStatus: form.status,
          breathworkCategory: selectedCategory?.value,
          breathworkLottie: form.breathworkLottie,
          approvalStatus: parseInt(form.approvalStatus),
          isExpertImageDeleted: isExpertImgDeleted && selectedExpert === '' ? true : false
        };


        // if (form?.breathworkId && categorys?.length > 0) {
        //   payload['category_ids'] = categorys;
        // } else {
        //   if (!form?.breathworkId && categorys?.length > 0) {
        //     payload['category_ids'] = categorys;
        //   }
        // }

        if (form?.breathworkId) {
          payload['removeLanguages'] = removeLanguage;
        }

        payload['focusIds'] = null;

        // if (form?.breathworkId && tempFocusIdArray?.length > 0) {
        //   payload['focusIds'] = tempFocusIdArray;
        // } else {
        //   if (!form?.breathworkId && tempFocusIdArray?.length > 0) {
        //     payload['focusIds'] = tempFocusIdArray;
        //   }
        // }

        !selectedBreathwork?.type && delete payload['breathworkImage'];
        !selectedFile3?.type && delete payload['bg_audio'];
        !selectedFile2?.type && delete payload['video_url'];
        !selectedFile?.type && delete payload['breathworkUrl'];

        if (form.breathworkId && selectedBreathwork === '') {
          payload['breathworkImage'] = '';
        }
        if (form.breathworkId && selectedFile3 === '') {
          payload['bg_audio'] = '';
        }
        if (form.breathworkId && selectedFile2 === '') {
          payload['video_url'] = '';
        }
        if (form.breathworkId && selectedFile === '') {
          payload['breathworkUrl'] = '';
        }

        payload['multi_language'] = audios?.map((item) => {
          return {
            language: item?.language,
            duration: item?.duration,
            audio: item?.file ? getFileType(item?.file) : item?.audio?.split('/').at(-1),
            srt: item?.srt ? item?.srt?.split('/').at(-1) : ''
          };
        });

        Api.addBreathwork(payload).then(async (response) => {
          if (response?.data?.meta?.code === 1) {
            if (response?.data?.meta?.audioUrl?.uploadURL) {
              await axios.put(response?.data?.meta?.audioUrl?.uploadURL, selectedFile, {
                headers: {
                  'content-type': `${selectedFile?.type?.split('/')[0]}/${
                    selectedFile?.name?.split('.')[1]
                  }`
                }
              });
            }
            if (response?.data?.meta?.breathworkImageUrl?.uploadURL) {
              await axios.put(
                response?.data?.meta?.breathworkImageUrl?.uploadURL,
                selectedBreathwork,
                {
                  headers: {
                    'content-type': `${selectedBreathwork?.type?.split('/')[0]}/${
                      selectedBreathwork?.name?.split('.')[1]
                    }`
                  }
                }
              );
            }

            if (response?.data?.meta?.bg_audio?.uploadURL) {
              await axios.put(response?.data?.meta?.bg_audio?.uploadURL, selectedFile3, {
                headers: {
                  'content-type': `${selectedFile3?.type?.split('/')[0]}/${
                    selectedFile3?.name?.split('.')[1]
                  }`
                }
              });
            }

            if (response?.data?.meta?.videoUrl?.uploadURL) {
              await axios.put(response?.data?.meta?.videoUrl?.uploadURL, selectedFile2, {
                headers: {
                  'content-type': `${selectedFile2?.type?.split('/')[0]}/${
                    selectedFile2?.name?.split('.')[1]
                  }`
                }
              });
            }

            if (response?.data?.meta?.multi_language && audios?.length > 0) {
              audios?.map(async (item, index) => {
                if (
                  item?.file &&
                  response?.data?.meta?.multi_language?.[`ques${index + 1}Audio`]?.uploadURL
                ) {
                  await axios.put(
                    response?.data?.meta?.multi_language?.[`ques${index + 1}Audio`]?.uploadURL,
                    item?.file,
                    {
                      headers: {
                        'content-type': `${item?.file?.type?.split('/')[0]}/${
                          item?.file?.name?.split('.')[1]
                        }`
                      }
                    }
                  );
                }
              });
            }

            successToast(response.data.meta.message);
            navigate('/breathwork/manage', {
              state: { flag: userData?.userType ? 0 : null }
            });
          } else if (response?.data?.meta?.code === 0) {
            setLoader(false);
            errorToast(response.data.meta.message);
          } else {
            setLoader(false);
          }
        });
        // .finally(() => {
        //   setLoader(false);
        // });
      }
    } else {
      setError(errors);
    }
  };

  const handleDraft = (e, fromPopup = false) => {
    e.preventDefault();
    if (propsData && !fromPopup) {
      setOpenConfirmPopupDraft(true);
    } else {
      // let tempFocusIdArray = selectedCategory?.map((data) => {
      //   return data?.focuses;
      // });

      // tempFocusIdArray = [].concat(...tempFocusIdArray);

      // const categorys = categoriesList
      //   ?.filter((c) => selectedCategory?.find((f) => f?.name === c?.name))
      //   ?.map((c) => c?._id);

      setLoader(true);
      const payload = {
        breathworkId: form.breathworkId,
        breathworkName: form.breathworkTitle,
        breathworkType: form.breathworkType,
        description: form.description,
        isBasic: isBasicBreathwork == 'true' ? true : false,
        isDraft: true,
        breathworkUrl: selectedFile?.type ? getFileType(selectedFile) : '',
        bg_audio: selectedFile3?.type ? getFileType(selectedFile3) : '',
        video_url: selectedFile2?.type ? getFileType(selectedFile2) : '',
        breathworkImage: selectedBreathwork?.type ? getFileType(selectedBreathwork) : '',
        expertId: selected?.id,
        expertName: selected?.name,
        duration:
          +minutes2 !== 0 || +sec2 !== 0
            ? `${minutes2}:${sec2}`
            : +minutes !== 0 || +sec !== 0
            ? `${minutes}:${sec}`
            : `${minutes}:${sec}`,
        breathworkStatus: form.status,
        breathworkCategory: selectedCategory?.value,
        breathworkLottie: form.breathworkLottie,
        approvalStatus: parseInt(form.approvalStatus),
        isExpertImageDeleted: isExpertImgDeleted && selectedExpert === '' ? true : false
      };

      // if (form?.breathworkId && categorys?.length > 0) {
      //   payload['category_ids'] = categorys;
      // } else {
      //   if (!form?.breathworkId && categorys?.length > 0) {
      //     payload['category_ids'] = categorys;
      //   }
      // }

      payload['focusIds'] = null;

      // if (form?.breathworkId && tempFocusIdArray?.length > 0) {
      //   payload['focusIds'] = tempFocusIdArray;
      // } else {
      //   if (!form?.breathworkId && tempFocusIdArray?.length > 0) {
      //     payload['focusIds'] = tempFocusIdArray;
      //   }
      // }

      !selectedBreathwork?.type && delete payload['breathworkImage'];
      !selectedFile3?.type && delete payload['bg_audio'];
      !selectedFile2?.type && delete payload['video_url'];
      !selectedFile?.type && delete payload['breathworkUrl'];

      if (form.breathworkId && selectedBreathwork === '') {
        payload['breathworkImage'] = '';
      }
      if (form.breathworkId && selectedFile3 === '') {
        payload['bg_audio'] = '';
      }
      if (form.breathworkId && selectedFile2 === '') {
        payload['video_url'] = '';
      }
      if (form.breathworkId && selectedFile === '') {
        payload['breathworkUrl'] = '';
      }

      payload['multi_language'] = audios?.map((item) => {
        return {
          language: item?.language,
          duration: item?.duration,
          audio: item?.file ? getFileType(item?.file) : item?.audio?.split('/').at(-1),
          srt: item?.srt ? item?.srt?.split('/').at(-1) : ''
        };
      });

      Api.addDraftbreathwork(payload)
        .then(async (response) => {
          if (response?.data?.meta?.code === 1) {
            if (response?.data?.meta?.audioUrl?.uploadURL) {
              await axios.put(response?.data?.meta?.audioUrl?.uploadURL, selectedFile, {
                headers: {
                  'content-type': `${selectedFile?.type?.split('/')[0]}/${
                    selectedFile?.name?.split('.')[1]
                  }`
                }
              });
            }
            if (response?.data?.meta?.breathworkImageUrl?.uploadURL) {
              await axios.put(
                response?.data?.meta?.breathworkImageUrl?.uploadURL,
                selectedBreathwork,
                {
                  headers: {
                    'content-type': `${selectedBreathwork?.type?.split('/')[0]}/${
                      selectedBreathwork?.name?.split('.')[1]
                    }`
                  }
                }
              );
            }
            if (response?.data?.meta?.bg_audio?.uploadURL) {
              await axios.put(response?.data?.meta?.bg_audio?.uploadURL, selectedFile3, {
                headers: {
                  'content-type': `${selectedFile3?.type?.split('/')[0]}/${
                    selectedFile3?.name?.split('.')[1]
                  }`
                }
              });
            }

            if (response?.data?.meta?.videoUrl?.uploadURL) {
              await axios.put(response?.data?.meta?.videoUrl?.uploadURL, selectedFile2, {
                headers: {
                  'content-type': `${selectedFile2?.type?.split('/')[0]}/${
                    selectedFile2?.name?.split('.')[1]
                  }`
                }
              });
            }

            if (response?.data?.meta?.multi_language && audios?.length > 0) {
              audios?.map(async (item, index) => {
                if (
                  item?.file &&
                  response?.data?.meta?.multi_language?.[`ques${index + 1}Audio`]?.uploadURL
                ) {
                  await axios.put(
                    response?.data?.meta?.multi_language?.[`ques${index + 1}Audio`]?.uploadURL,
                    item?.file,
                    {
                      headers: {
                        'content-type': `${item?.file?.type?.split('/')[0]}/${
                          item?.file?.name?.split('.')[1]
                        }`
                      }
                    }
                  );
                }
              });
            }

            successToast(response.data.meta.message);

            navigate('/breathwork/manage', {
              state: { flag: userData?.userType ? 0 : null }
            });
          } else if (response?.data?.meta?.code === 0) {
            setLoader(false);
            errorToast(response.data.meta.message);
          } else {
            setLoader(false);
          }
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  useEffect(() => {
    // Api.getCategoriesById(11).then((res) => {
    //   setCategoriesList(
    //     res?.data?.data?.map((item) => {
    //       return {
    //         ...item,
    //         label: item?.name,
    //         value: item?.name
    //       };
    //     })
    //   );
    //   if (!propsData?.id) {
    //     setLoader(false);
    //   }
    // });
    setCategoriesList(pageData.categoryList);
    setLoader(false);
  }, []);

  const radioHandler = (e) => {
    let { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: parseInt(value)
    }));
  };

  const isBasicRadioHandler = (e) => {
    let { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: value === 'true'
    }));
  };

  const fetchBreathworkData = async (expertsData) => {
    try {
      const response = await Api.getBreathworkById(id ? id : propsData?.id || propsData?._id);
      if (response?.data?.meta?.code === 1) {
        setLoader(false);
        const breathworkData = response?.data?.data;
        setBgAudio(breathworkData?.bg_audio);
        setVideo(breathworkData?.video_url);
        setSelectedFile2(breathworkData?.video_url);
        setSelectedFile3(breathworkData?.bg_audio);
        setAudio(breathworkData.audioUrl);
        if (breathworkData?.multi_language?.length) {
          setAudios(breathworkData?.multi_language);
        }
        setSelectedFile(breathworkData.audioUrl);
        setSelectedExpert(breathworkData?.expertImage || '');
        setselectedBreathwork(breathworkData?.breathworkImage);
        setPreviewExpert(breathworkData?.expertImage);
        setSelectedLanguages(breathworkData?.multi_language?.map((item) => item?.language) || []);
        setPreviewMeditation(breathworkData?.breathworkImage);

        const focusArray =
          breathworkData?.focus?.map((item) => ({
            id: item?._id,
            name: item.display_name,
            checked: true
          })) || [];
        setSelectedFocus(focusArray);

        const expertName =
          breathworkData?.expertName ||
          (breathworkData?.expertId
            ? expertsList.find((expert) => expert.id === breathworkData.expertId)?.name
            : '');

        setForm({
          breathworkId: breathworkData?.id,
          breathworkTitle: breathworkData?.breathworkName,
          description: breathworkData?.description,
          breathworkType: breathworkData?.breathworkType,
          status: breathworkData?.breathworkStatus,
          approvalStatus: breathworkData?.approvalStatus,
          breathworkCategory: breathworkData?.breathworkCategory,
          breathworkLottie: breathworkData?.breathworkLottie,
          isBasic: breathworkData?.isBasic ?? false,
          expertName: expertName,
          comments: breathworkData?.comments
        });

        breathworkData?.video_url !== null &&
          setMinutes2(parseInt(breathworkData?.duration?.split(':')[0]));
        breathworkData?.video_url !== null &&
          setSec2(parseInt(breathworkData?.duration?.split(':')[1]));
        breathworkData?.video_url === null &&
          setMinutes(parseInt(breathworkData?.duration?.split(':')[0]));
        breathworkData?.video_url === null &&
          setSec(parseInt(breathworkData?.duration?.split(':')[1]));

        setSelected(expertsList?.find((res) => res?.id === breathworkData?.expertId));

        // console.log('categoriesList===>', categoriesList);
        // console.log(
        //   'breathworkData===>',
        //   breathworkData?.breathworkCategory,
        //   categoriesList?.filter((res) => res.value === breathworkData?.breathworkCategory)
        // );

        setSelectedCategory(
          categoriesList?.filter(
            (res) => String(res.value) === String(breathworkData?.breathworkCategory)
          ) || []
        );
        setSelectedLottie(
          BREATHWORK_LOTTIES?.find((prev) => breathworkData?.breathworkLottie === prev?.value)
        );
        setSrtUrl(breathworkData?.srtUrl);
        setSrtName(breathworkData?.breathworkSrtName);
      } else {
        setLoader(false);

        const handleErrorResponse = (response) => {
          setLoader(false);
          if (response?.code === 401) {
            errorToast(response?.message);
          } else if (response?.data?.meta?.code === 0) {
            errorToast(response?.data?.meta?.message);
          }
        };
        handleErrorResponse(response);
      }
    } catch (error) {
      console.error('Error fetching breathwork data:', error);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (expertsList?.length > 0 && (propsData?.id || propsData?._id || id)) {
      fetchBreathworkData(expertsList);
    }
  }, [expertsList, propsData, id]);

  useEffect(() => {
    const fetchPodExperts = async () => {
      try {
        const res = await Api.getPodExpertsName();
        const filteredData = res.data.data.filter((item) => item.type === 0);
        setExpertsList(
          filteredData?.map((item) => {
            return {
              ...item,
              label: item?.name,
              value: item?.name
            };
          })
        );
        setExpertsLists(
          filteredData?.map((item) => {
            return {
              ...item,
              label: item?.name,
              value: item?.name
            };
          })
        );
        return filteredData;
      } catch (error) {
        console.error('Error fetching pod experts:', error);
      }
    };

    const initializeData = async () => {
      const expertsData = await fetchPodExperts();
      if (propsData) {
        setLoader(true);
        setPages([
          { name: pageData.mainPageTitle, href: '/breathwork/manage' },
          {
            name: `${
              propsData?.action === 'view'
                ? pageData.viewBreathworkPageTitle
                : pageData.editBreathworkPageTitle
            }`,
            href: `/breathwork/manage/${
              propsData?.action === 'view' ? 'view' : 'add-edit'
            }`
          }
        ]);
        setIsView(propsData?.action === 'view');
        await fetchBreathworkData(expertsData);
        setLoader(false);
      } else {
        // setInterval(() => {
        //   setLoader(false);
        // }, 1000);
      }
    };

    initializeData();
  }, [propsData, refresh]);
  useEffect(() => {
    const filteredJobs =
      query === ''
        ? expertsLists
        : expertsLists.filter((job) => {
            return job.name.toLowerCase().includes(query.toLowerCase());
          });
    setExpertsList(
      filteredJobs?.map((item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.name
        };
      })
    );
  }, [query]);

  const handleMeditationImage = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedExpert(undefined);
      return;
    }
    if (e?.target?.files[0]?.size > 1048576) {
      errorToast(pageData.fileShouldBeLessThan1MB);
    } else {
      if (e?.target?.files[0]) {
        if (!e?.target?.files[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
          errorToast(
            `${pageData.validImageErrorMessageBeforeFileName} ${e?.target?.files[0].name} ${pageData.validImageErrorMessageafterFileName}`
          );
        } else {
          setselectedBreathwork(e.target.files[0]);
          const objectUrl = URL.createObjectURL(e.target.files[0]);
          setPreviewMeditation(objectUrl);
          return () => URL.revokeObjectURL(objectUrl);
        }
      } else {
        setPreviewMeditation(undefined);
      }
    }
  };

  const handleAudio = (e, index) => {
    const audioFile = e?.target?.files[0];
    if (!audioFile) return;
    if (!audioFile.name.match(/\.(mp3|wav)$/i)) {
      errorToast(
        `${pageData.uploadAudioFileErrorMessageBeforeName} ${audioFile.name}${pageData.uploadAudioFileErrorMessageAfterName}`
      );
      return;
    }
    const audio = new Audio(URL.createObjectURL(audioFile));
    audio.onloadedmetadata = () => {
      const duration = audio.duration;
      const minutes = Math.floor(duration / 60);
      const remainingSeconds = Math.floor(duration % 60);
      setAudios((prev) => {
        const updatedData = [...prev];
        updatedData[index] = {
          ...updatedData[index],
          audio: URL.createObjectURL(audioFile),
          file: audioFile,
          duration: `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(
            2,
            '0'
          )}`
        };
        return updatedData;
      });
      if (audioRefs.current[index]) {
        audioRefs.current[index].src = URL.createObjectURL(audioFile);
      }
    };
    setError((prev) => {
      return {
        ...prev,
        ['audio' + index]: ''
      };
    });
  };

  const removeFile = (index) => {
    setAudios((prev) => {
      const prevData = [...prev];
      return prevData.map((data, i) => {
        if (i === index) {
          return {
            ...data,
            audio: '',
            file: '',
            duration: ''
          };
        } else {
          return data;
        }
      });
    });
  };

  const handleCaption = (e, language) => {
    if (e?.target?.files[0]) {
      if (!e?.target?.files[0].name.match(/\.(srt)$/i)) {
        errorToast(
          `${pageData.uploadSrtFileErrorMessageBeforeName} ${e?.target?.files[0].name} ${pageData.uploadSrtFileErrorMessageAfterName}`
        );
      } else {
        // setSelectedCaptionFile(e.target.files[0]);

        let payload = {
          srtUrl: e.target.files[0] ? getFileType(e.target.files[0]) : null,
          contentType: 11,
          contentId: form?.breathworkId,
          language: language
        };

        Api.updateSrtData(payload)
          .then(async (response) => {
            if (response?.data?.meta?.code === 1) {
              if (response?.data?.data?.uploadURL) {
                await axios.put(response?.data?.data?.uploadURL, e.target.files[0], {
                  headers: {
                    'content-type': `${e.target.files[0]?.type?.split('/')[0]}/${
                      e.target.files[0]?.name?.split('.')[1]
                    }`
                  }
                });
                successToast(pageData.captionFileUpdatedSuccessMessage);
                setRefresh(refresh + 1);
              }
            } else {
              errorToast(pageData.captionFileNotUpdatedErrorMessage);
            }
          })
          .catch((err) => console.log(err));
      }
    }
  };

  return (
    <div className="relative">
      {loader && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        {propsData?.action === 'view' ? (
          <title>{pageData.viewBreathworkMetaTitle}</title>
        ) : propsData?.action === 'edit' ? (
          <title>{pageData.editBreathworkMetaTitle}</title>
        ) : (
          <title>{pageData.addBreathworkMetaTitle}</title>
        )}
      </Helmet>
      <Topbar
        title={
          propsData?.action === 'view'
            ? pageData.viewBreathworkPageTitle
            : propsData?.action === 'edit'
            ? pageData.editBreathworkPageTitle
            : pageData.addBreathworkPageTitle
        }
      />
      <Breadcrumb pageList={pages} className="lg:mt-8" />
      <div className="bg-white dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg border-[1.5px] border-shoorah-borderGray dark:border-transparent lg:rounded-2xl rounded-xl md:px-6 lg:py-10 md:py-6 p-4 lg:mt-10 w-full">
        <div className="grid lg:gap-5 gap-4 2xl:gap-10 md:grid-cols-2 2xl:grid-cols-3 grid-cols-1">
          <div className="lg:space-y-6 space-y-4 w-full">
            <InputWithLabel
              label={pageData.breathworkNameLabel}
              placeholder={pageData.breathworkNamePlaceholder}
              onChange={handleChange}
              errorMargin="mt-1"
              labelMargin="mb-1"
              errorSize="text-[12px]"
              isLengthValidate={true}
              limit={MaxCharlimit}
              labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
              value={form.breathworkTitle}
              name={'breathworkTitle'}
              id={'breathworkTitle'}
              error={error?.breathworkTitle}
              isRequired={true}
              disabled={isView || view}
            />
            {!isView && (
              <div className="mt-4">
                <label
                  htmlFor="breathworkName"
                  className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm"
                >
                  {pageData.breathworkImageLabelWithSize}
                </label>
                <div className="mt-1">
                  {previewMeditation ? (
                    <>
                      <div className="relative">
                        <div
                          onClick={() => breathworkFile.current.click()}
                          className="h-10 flex items-center justify-between gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBorder dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray"
                        >
                          <p className="truncate mr-6">
                            {selectedBreathwork?.name
                              ? selectedBreathwork?.name
                              : previewMeditation?.split('/')[
                                  previewMeditation?.split('/')?.length - 1
                                ]}
                          </p>
                        </div>
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="hidden"
                          ref={breathworkFile}
                          onChange={(e) => handleMeditationImage(e)}
                        />

                        <XMarkIcon
                          className="absolute top-1/2 transform -translate-y-1/2 right-[10px] w-[20px] text-red-500 cursor-pointer"
                          onClick={() => {
                            setselectedBreathwork('');
                            setPreviewMeditation('');
                          }}
                        />
                      </div>
                      <div className="mx-auto border rounded-lg mt-2 text-center">
                        <LazyLoadImageProp
                          imageSrc={previewMeditation}
                          className="mx-auto max-h-[250px]"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        className="hidden"
                        ref={breathworkFile}
                        onChange={(e) => handleMeditationImage(e)}
                      />
                      <div
                        onClick={() => breathworkFile.current.click()}
                        className="flex justify-center items-center overflow-hidden rounded-[9px] border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder w-full h-[240px] bg-shoorah-normanGray dark:bg-shoorah-darkBgColor relative"
                      >
                        <div className="flex flex-col justify-center items-center">
                          <Icons.videoUploadIcon className="mb-5 text-shoorah-primary" />
                          <h5 className="text-xs">
                            {pageData.dropYourImageText}{' '}
                            <span className="text-shoorah-primary font-medium">
                              {pageData.browseText}
                            </span>
                          </h5>
                          <p className="text-shoorah-gray9 text-[8px] leading-[12px]">
                            {pageData.imageSupprotFileType}
                          </p>
                        </div>
                      </div>
                      <span className="text-red-500 text-[12px] mt-1">{error.meditationImage}</span>
                    </>
                  )}
                </div>
              </div>
            )}
            {isView && (
              <div className="mt-4">
                <label
                  htmlFor="breathworkName"
                  className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm"
                >
                  {pageData.breathworkImageLabel}
                </label>
                <div className="mx-auto border rounded-lg mt-2 text-center">
                  <LazyLoadImageProp
                    imageSrc={previewMeditation}
                    className="mx-auto max-h-[250px]"
                  />
                </div>
              </div>
            )}

            <div>
              <div className="flex w-full flex-col">
                <label
                  htmlFor="breathworkLottie"
                  className="text-sm font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1"
                >
                  {pageData.selectLottieFileLabel}
                </label>
                <CommonSelect
                  disabled={isView || view}
                  name="expert"
                  onChange={(e) => {
                    setSelectedLottie(e);
                  }}
                  value={BREATHWORK_LOTTIES.find(
                    (option) => option?.value === selectedLottie?.value
                  )}
                  options={BREATHWORK_LOTTIES}
                />
              </div>
            </div>
            <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
              <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                {pageData.isBasicFrameworkLabel}
              </label>
              <fieldset className="mt-2">
                <div className="flex space-x-4">
                  {BASIC_BREATHWORK.map((basic, index) => (
                    <div key={index} className="flex items-center">
                      <input
                        id={basic.name}
                        name="isBasic"
                        type="radio"
                        value={basic.value}
                        onChange={(e) => isBasicRadioHandler(e)}
                        disabled={isView || view}
                        checked={basic.value == form.isBasic}
                        className="h-5 w-5 border-gray-300 text-shoorah-primary focus:ring-shoorah-primary"
                      />
                      <label
                        htmlFor={basic.name}
                        className="ml-3 block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        {basic.name}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
          </div>
          <div className="lg:space-y-6 space-y-4 w-full">
            <div>
              <div className="flex w-full flex-col">
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  {pageData.selectCategoriesLabel}{' '}
                  {!isView && !view && <span className="text-red-400">&#42;</span>}
                </label>
                <CommonSelect
                  disabled={isView || view}
                  name="categories"
                  controlCustomStyle={{ padding: '1px' }}
                  isMulti={false}
                  onChange={(e) => {
                    setSelectedCategory(e);
                    setError((prev) => ({ ...prev, focus: '' }));
                  }}
                  value={selectedCategory}
                  options={categoriesList}
                />
                <span className="text-red-500 text-[12px] mt-1">{error.focus}</span>
              </div>
            </div>
            <TextareaWithLabel
              label={pageData.descriptionLabel}
              placeholder={pageData.descriptionPlaceholder}
              onChange={handleChange}
              errorMargin="mt-1"
              labelMargin="mb-1"
              errorSize="text-[12px]"
              className="min-h-[240px]"
              isLengthValidate={true}
              limit={MaxCharlimitLongText}
              labelClassName="text-sm text-gray-700 dark:text-shoorah-darkBg"
              value={form.description}
              name={'description'}
              id={'description'}
              error={error?.description}
              isRequired={true}
              disabled={isView || view}
            />

            {/* {isView && (
              <div>
                <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                  Breathwork Audio
                </label>
                <div className="relative">
                  <FormAudioPlayer
                    id="audio"
                    audio={audio}
                    setMin={setMinutes}
                    setSec={setSec}
                    audioEl={audioE1}
                  />
                </div>
              </div>
            )} */}

            <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
              <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                {pageData.selectExpertLabel}
                <span className="text-red-400"> &#42;</span>
              </label>
              <CommonSelect
                disabled={isView || view}
                name="expert"
                onChange={(e) => {
                  setSelected(e);
                  setError((prev) => ({ ...prev, expertId: '' }));
                }}
                value={expertsList?.find((option) => option?.value === selected?.value)}
                options={expertsList}
              />
              <span className="text-red-500 text-[12px] mt-1">{error.expertId}</span>
            </div>
            <div className={`${isView ? 'cursor-default' : 'cursor-pointer'}`}>
              <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                {pageData.statusLabel}
              </label>
              <fieldset className="mt-2">
                <div className="flex space-x-4">
                  {STATUS.map((status, index) => (
                    <div key={index} className="flex items-center">
                      <input
                        id={status.name}
                        name="status"
                        type="radio"
                        value={status.value}
                        onChange={(e) => radioHandler(e)}
                        disabled={isView || view}
                        checked={status.value === form.status}
                        className="h-5 w-5 border-gray-300 text-shoorah-primary focus:ring-shoorah-primary"
                      />
                      <label
                        htmlFor={status.name}
                        className="ml-3 block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        {status.name}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
          </div>
          <div className="md:col-span-2">
            <div
              key={''}
              className="grid md:grid-cols-2 grid-cols-1 lg:gap-x-5 lg:gap-y-6 gap-y-4 gap-x-4 2xl:gap-x-10 content-center"
            >
              {/* <div className="flex justify-end md:col-span-2">
                {!isView && !view && (
                  <button
                    onClick={() =>
                      setAudios((audios) => [
                        ...audios,
                        { language: '', audio: '', file: null, srt: '', duration: '' }
                      ])
                    }
                    className="btn-primary"
                  >
                    Add Audio
                  </button>
                )}
              </div> */}
            </div>
            {audios?.length > 0 &&
              audios?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="grid md:grid-cols-2 grid-cols-1 lg:gap-x-5 lg:gap-y-6 gap-y-4 gap-x-4 2xl:gap-x-10 content-center"
                  >
                    <div className="flex justify-end md:col-span-2">
                      {index === 0 && audios?.length !== LANGUAGES?.length && !isView && !view && (
                        <button
                          onClick={() =>
                            setAudios((audios) => [
                              ...audios,
                              {
                                language: '',
                                audio: '',
                                file: null,
                                srt: '',
                                duration: ''
                              }
                            ])
                          }
                          className="btn-primary"
                        >
                          {pageData.addAudioBtnText}
                        </button>
                      )}
                    </div>
                    {audios?.length > 1 && (
                      <div className={`flex justify-end col-span-2 ${index === 0 ? 'mt-4' : ''}`}>
                        <button
                          onClick={() => {
                            !removeLanguage?.includes(item.language) &&
                              setRemoveLanguage((prev) => [...prev, item.language]);
                            setAudios((audios) => [...audios?.filter((_, i) => i !== index)]);
                            setError((prev) => ({
                              ...prev,
                              ['audio' + index]: '',
                              ['language' + index]: ''
                            }));
                            setSelectedLanguages((prev) => {
                              const prevData = [...prev];
                              const updatedData = prevData.filter((p) => p !== item?.language);
                              return updatedData;
                            });
                          }}
                        >
                          <XMarkIcon color="#000" className="size-6" />
                        </button>
                      </div>
                    )}
                    <div>
                      <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                        {pageData.audioLanguageLabel}{' '}
                        {!isView && !view && <span className="text-red-400">&#42;</span>}
                      </label>
                      <CommonSelect
                        disabled={isView || view}
                        name="language"
                        onChange={(e) => handelAudiosLanguage(e, index)}
                        value={LANGUAGES.find((option) => option?.value === item.language)}
                        options={LANGUAGES.filter(
                          (option) => !selectedLanguages.includes(option.value)
                        )}
                      />
                      <span className="text-red-500 text-[12px] mt-1">
                        {error?.['language' + index]}
                      </span>
                    </div>
                    {isView && (
                      <div>
                        <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                          {pageData.uploadAudioLabel}
                        </label>
                        <div className="relative">
                          <FormAudioPlayer
                            id="audio"
                            audio={item?.audio}
                            index={index}
                            setMin={setMinutes}
                            setSec={setSec}
                            audioEl={audioE1}
                          />
                        </div>
                      </div>
                    )}
                    {!isView && (
                      <div>
                        <label className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm">
                          {pageData.uploadAudioLabel}{' '}
                          {!isView && !view && <span className="text-red-400">&#42;</span>}
                        </label>
                        {item?.audio ? (
                          <>
                            <div className="relative">
                              <div className="h-10 flex items-center justify-between gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBorder dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray">
                                <p className="truncate mr-6">
                                  {item?.file?.name
                                    ? item?.file?.name
                                    : item?.audio?.split('/')[item?.audio?.split('/').length - 1]}
                                </p>
                              </div>
                              <input
                                type="file"
                                className="bg-black hidden"
                                ref={(el) => (audioRefs.current[index] = el)}
                                onChange={(e) => handleAudio(e, index)}
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                                accept=".mp3,audio/*"
                              />
                              <XMarkIcon
                                className="absolute top-1/2 transform -translate-y-1/2 right-[10px] w-[20px] text-red-500 cursor-pointer"
                                onClick={() => removeFile(index)}
                              />
                            </div>
                            <FormAudioPlayer
                              audio={audios[index]?.audio}
                              setMin={setMinutes}
                              setSec={setSec}
                              audioEl={(el) => (audioRefs.current[index] = el)}
                            />
                          </>
                        ) : (
                          <>
                            <div className="mt-1">
                              <button
                                type="button"
                                onClick={() => audioRefs.current[index].click()}
                                className="h-10 flex items-center justify-center gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBorder dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray"
                              >
                                <ArrowUpTrayIcon className="w-[20px] inline" />
                                {pageData.uploadBtnText}
                              </button>
                              <input
                                type="file"
                                className="bg-black hidden"
                                ref={(el) => (audioRefs.current[index] = el)}
                                onChange={(e) => handleAudio(e, index)}
                                accept=".mp3,audio/*"
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                              />
                            </div>
                            <span className="text-red-500 text-[12px] mt-1">
                              {error.meditationFile}
                            </span>
                          </>
                        )}
                        <span className="text-red-500 text-[12px] mt-1">
                          {error?.['audio' + index]}
                        </span>
                      </div>
                    )}

                    {item?.duration && (
                      <div>
                        <label
                          htmlFor="meditationName"
                          className="font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1 block text-sm"
                        >
                          {pageData.durationLabel}
                        </label>
                        <Duration
                          min={item?.duration && item?.duration?.split(':')[0]}
                          sec={item?.duration && item?.duration?.split(':')[1]}
                          setSec={setSec}
                          setMin={setMinutes}
                          disabled
                        />
                      </div>
                    )}

                    {item?.srt && item?.audio && (
                      <div className="flex flex-wrap gap-3">
                        <button className="h-10 flex items-center justify-center gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBorder dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray my-auto">
                          <a
                            href={item?.srt}
                            className="text-shoorah-primary flex gap-3 items-center"
                          >
                            <ArrowDownTrayIcon className="w-[20px] inline" />
                            {pageData.downloadCaptionFileLabel}
                          </a>
                        </button>
                        {!isView && !view && (
                          <label
                            htmlFor={`srt${index}`}
                            className="h-10 flex items-center justify-center gap-3 w-full rounded-lg px-4 py-[8px] text-sm text-shoorah-lightBlack dark:border-shoorah-darkBorder dark:text-shoorah-darkBg appearance-none placeholder-gray-400 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-[1.5px] border-shoorah-borderGray my-auto pr-9"
                          >
                            <ArrowUpTrayIcon className="w-[20px] inline" />
                            {pageData.updateCaptionFileLabel}
                          </label>
                        )}
                        <input
                          type="file"
                          name="srt"
                          id={`srt${index}`}
                          className="bg-black hidden"
                          onChange={(e) => handleCaption(e, item?.language)}
                          accept=".srt"
                        />
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          {!isView && (
            <div className="md:col-span-2">
              <div className="lg:space-y-6 space-y-4 w-full flex justify-end">
                <div className="sm:text-right flex gap-x-4 sm:justify-end justify-start">
                  <div className="lg:block hidden">
                    <SecondaryButton btnText={pageData.cancelBtnText} btnType="button" />
                  </div>
                  <button
                    onClick={(e) => setOpenConfirmPopupDraft(true)}
                    id="draft"
                    className="btn-primary"
                  >
                    {pageData.saveDraftBtnText}
                  </button>
                  <button
                    onClick={handleSubmit}
                    className="btn-primary"
                  >
                    {userData?.userType
                      ? pageData.submitForApprovalBtnText
                      : pageData.submitBtnText}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {isView && form?.comments?.length > 0 && (
          <ApprovalHistory data={form?.comments} title={pageData.viewTitle} />
        )}
      </div>
      {openConfirmPopupSave && (
        <ConfirmPopup
          open={openConfirmPopupSave}
          setOpen={setOpenConfirmPopupSave}
          message={pageData.updateBreathworkDetailsConfirmMessage}
          setAccepted={(e) => handleSubmit(e, true)}
        />
      )}
      {openConfirmPopupDraft && (
        <ConfirmPopup
          open={openConfirmPopupDraft}
          setOpen={setOpenConfirmPopupDraft}
          message={pageData.updateBreathworkDetailsConfirmMessage}
          setAccepted={(e) => handleDraft(e, true)}
        />
      )}
    </div>
  );
}

AddEditBreathwork.propTypes = {
  location: PropTypes.any
};